export enum OrgType {
  Admin = 'Admin',
  Operators = 'Operators',
  Suppliers = 'Suppliers',
  None = 'None',
  ExternalResearcher = 'External Researcher',
}

export const OrgTypeOptions = Object.keys(OrgType);
